var map = {
	"./en-gb": 8,
	"./en-gb.js": 8,
	"./et": 9,
	"./et.js": 9,
	"./lt": 10,
	"./lt.js": 10,
	"./lv": 11,
	"./lv.js": 11,
	"./ru": 12,
	"./ru.js": 12
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/lib/moment/locale ^\.\/.*$
// module id = 25
// module chunks = 0 1